import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RemainContactComponent } from './components/remain-contact/remain-contact.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [],
    component: RemainContactComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RemainContactRoutingModule { }